<template>
  <div class="returnCarBegin-detail">
    <QS-scroller-box>
      <p class="title">发起退车</p>
      <form-text-box
        :column="3"
        :dataList="returnCarInfo.list"
        :model="returnCarInfo.model"
        :rules="returnCarInfo.rules"
      />

      <QS-h4-title title="车辆信息" />
      <form-text-box
        :column="3"
        :dataList="carInfo.list"
        :model="carInfo.model"
      />

      <QS-h4-title title="订单信息" />
      <form-text-box
        :column="3"
        :dataList="orderInfo.list"
        :model="orderInfo.model"
      />

      <QS-h4-title title="客户信息" />
      <form-text-box
        :column="3"
        :dataList="customerInfo.list"
        :model="customerInfo.model"
      />
    </QS-scroller-box>
  </div>
</template>

<script>
import { ORDER_TYPES, ORDER_STATES } from '@/pages/cars/returnCar/config'
import { mixin } from './config'

export default {
  mixins: [mixin],
  inject: ['orderType', 'orderData', 'returnCarOrderData'],
  data() {
    return {
      queries: JSON.parse(decodeURIComponent(this.$route.query.query || '{}')),
    }
  },
  methods: {
    // 回填订单信息
    backfillOrderInfo(data) {
      const returnCarInfoModel = {
        // 车牌号
        plateNo: data.plateNo || '',
        // 客户名称
        customerName: data.customerName || '',
        // 所属部门名称
        deptName: data.deptName || '',
        // 订单ID
        id: data.id || '',
        // 退车类型
        returnType: '',
        // 退车原因
        returnReason: '',
      }
      const carInfoModel = {
        // 车牌号
        plateNo: data.plateNo || '',
        // 车辆ID
        carId: data.carId || '',
        // 车型
        modelName: data.modelName || '',
        // 车辆状态
        carState: data.carState || '',
        // 库存状态
        inventoryState: data.inventoryState === 1 ? '在库' : '出库',
        // 品牌
        brandName: data.brandName || '',
        // 车系
        seriesName: data.seriesName || '',
        vin: data.vin || '',
      }
      const orderInfoModel = {
        // 订单ID
        id: data.id || '',
        // 企业主订单ID
        entRentOrderId: data.entRentOrderId || '',
        // 订单类型
        type: this.orderType === ORDER_TYPES.personal.value ? '个人订单' : '企业子订单',
        // 订单状态
        state: (Object.values(ORDER_STATES).find((item) => item.value === data.state) || {}).name || '',
        // 收款起止日
        receivablePeriod: data.receivablePeriod || '',
        // 赠送天数
        presentDays: (data.presentDays || '') + (data.presentDays ? '天' : ''),
        // 免租周期
        presentDate: data.presentStartDate && data.presentEntDate ? `${data.presentStartDate} ~ ${data.presentEntDate}` : '',
        // 租金总金额
        totalAmount: (data.totalAmount || '') + (data.totalAmount && !String(data.totalAmount).endsWith('元') ? '元' : ''),
        // 押金金额
        totalDeposit: (data.totalDeposit || '') + (data.totalDeposit ? '元' : ''),
      }
      const customerInfoModel = {
        // 客户ID
        customerId: data.customerId || '',
        // 客户类型
        customerType: data.customerType === 1 ? '个人' : '企业',
        // 客户名称
        customerName: data.customerName || '',
      }

      this.returnCarInfo.model = returnCarInfoModel
      this.carInfo.model = carInfoModel
      this.orderInfo.model = orderInfoModel
      this.customerInfo.model = customerInfoModel
    },
    // 回填退车单信息（退车类型、退车原因）
    backfillReturnCarOrderInfo(data) {
      // 退车类型
      const returnType = data?.returnType || ''
      // 退车原因
      const returnReason = data?.returnReason || ''

      this.returnCarInfo.model.returnType = returnType
      this.returnCarInfo.model.returnReason = returnReason
    },
  },
  created() {
    const { id, orderId } = this.queries

    if (orderId) {
      this.backfillOrderInfo(this.orderData)
    }
    if (id || orderId) {
      this.backfillReturnCarOrderInfo(this.returnCarOrderData)
    }
  },
}
</script>

<style lang="scss" scoped>
  .title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-weight: 600;
    font-size: 16px;
    color: #323233;
    margin-bottom: 14px;
  }
  .btn-group {
    display: flex;
    justify-content: center;
  }
  .mt-36 {
    margin-top: 36px;
  }
</style>
